export const antdTheme = {
  token: {
    wireframe: false,
    colorPrimary: '#004615',
    colorInfo: '#004615',
    colorPrimaryBg: '#eaf2eb',
  },
  components: {
    Alert: {
      colorInfo: '#1677ff',
      colorInfoBg: '#e6f4ff',
      colorInfoBorder: '#91caff',
    },
    Card: {
      bodyPadding: 16,
    },
    Collapse: {
      headerBg: '#004615',
      colorTextHeading: '#FFFFFF',
    },
    Descriptions: {
      colorSplit: '#FFFFFF',
      lineWidth: 2,
    },
  },
};
